// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__YDmaS","Success":"Button_Success__1R5Ta","Danger":"Button_Danger__3tM1i"};